import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.css';
import {
  faAngleLeft,
  faAngleRight,
  faCalendarDays,
} from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import Select from '../../components/common/Select';
import { useGetCurrentUserQuery } from '../../api/userApi';
import EditSideBar from './components/EditSideBar';
import { GetCarAllocationCondition } from '../../types/carAllocation';
import {
  generateCarFormData,
  generateDriverFormData,
} from './generateRouteFormData';
import Map from './components/Map';
import { useGetAllocationsInDriverOrderQuery } from '../../api/carAllocationApi';
import OperatingRouteCalendar from './components/OperatingRouteCalendar';
import { format } from 'date-fns';
import { NavigateOptions, useSearchParams } from 'react-router-dom';
import { useGetDriversQuery } from '../../api/driverApi';
import { getDriversRequest } from '../../types/driver';
import HeaderLayout from '../../components/HeaderLayout';
import DateInput from '../../components/common/DateInput';

function Allocations() {
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);
  // 日時取得
  const [searchParams, setSearchParams] = useSearchParams();
  const getUrlDate = searchParams.get('date');
  const setDateParamu = (dateParam: Date, options?: NavigateOptions) => {
    setSearchParams((prev) => {
      prev.set('date', format(dateParam, 'yyyy-MM-dd'));
      return prev;
    }, options);
  };
  useEffect(() => {
    if (!getUrlDate) setDateParamu(new Date(), { replace: true });
  }, [getUrlDate]);
  const date =
    getUrlDate && !Number.isNaN(new Date(getUrlDate).getTime())
      ? new Date(getUrlDate)
      : new Date();
  const goNext = () => {
    const nowDate = date;
    nowDate.setDate(nowDate.getDate() + 1);
    setDateParamu(nowDate);
  };
  const goBefore = () => {
    const nowDate = date;
    nowDate.setDate(nowDate.getDate() - 1);
    setDateParamu(nowDate);
  };
  const changeDate = (nowDate: Date) => {
    setDateParamu(nowDate);
  };

  // ユーザ取得
  const setUserParamu = (userIdParam: number) => {
    setSearchParams((prev) => {
      prev.set('driverId', String(userIdParam));
      return prev;
    });
  };
  const getUrlDriverId = searchParams.get('driverId');
  const { data: myUser } = useGetCurrentUserQuery();
  const specifiedUserId = getUrlDriverId
    ? Number(getUrlDriverId)
    : myUser?.userId ?? null;
  const request: getDriversRequest = {
    driverName: '',
    skillLevelId: null,
    driverLicenseIds: [],
    carQualificationIds: [],
  };
  const { data: { drivers = [] } = {} } = useGetDriversQuery(request);
  const user =
    drivers.find((d) => d.userId === specifiedUserId)?.userId ?? null;
  useEffect(() => {
    const searchMyUser = drivers.filter(
      (c) => c.driverName === myUser?.userName
    );
    searchMyUser.length > 0 &&
      user === null &&
      setUserParamu(searchMyUser[0].userId);
  }, [drivers, user]);

  const usersOptions = drivers.map((c) => ({
    label: c.driverName,
    value: `${c.userId}`,
  }));
  const onChangeUser = (type: string) => {
    setUserParamu(Number(type));
  };

  // サイドバー
  const formatDate = (date: Date) => {
    return format(date, 'yyyy-MM-dd');
  };

  const initAllocations: GetCarAllocationCondition = {
    startDate: formatDate(date),
    endDate: formatDate(date),
    userId: user,
  };

  // userがnullの時は該当の運行データがないため、api取得をskipする
  const { data: allocations } = useGetAllocationsInDriverOrderQuery(
    initAllocations,
    { skip: user === null }
  );
  const responseDate = allocations?.drivers[0] || generateDriverFormData();

  return (
    <HeaderLayout
      title="運行ルート"
      controls={
        <>
          <div className={styles.monthDate}>
            <div className={styles.month}>
              <DateInput
                variants={['recently']}
                value={date}
                onChange={(day) => {
                  if (day) changeDate(day);
                }}
              />
            </div>
            <div className={styles.paging}>
              <button
                onClick={goBefore}
                onChange={() => goBefore()}
                className={classNames(styles.arrowButton)}
              >
                <FontAwesomeIcon icon={faAngleLeft} />
              </button>
              <button
                onClick={goNext}
                className={classNames(styles.arrowButton)}
              >
                <FontAwesomeIcon icon={faAngleRight} />
              </button>
            </div>
          </div>
          <div className={styles.userName}>
            <Select
              options={usersOptions}
              value={user !== null ? `${user}` : ''}
              onChange={(e) => onChangeUser(e.target.value)}
              variants={['fit', 'isAbbreviation']}
              placeholder={'ドライバー名'}
            ></Select>
          </div>
          <button
            type="button"
            className={styles.calendarButton}
            onClick={() => setIsOpenCalendar(!isOpenCalendar)}
          >
            <FontAwesomeIcon icon={faCalendarDays} />
          </button>
        </>
      }
    >
      <div className={classNames(!isOpenCalendar && styles.calendar)}>
        <OperatingRouteCalendar changedDate={changeDate} nowDate={date} />
      </div>
      <EditSideBar
        formData={responseDate || generateDriverFormData()}
        user={user}
        headerCalendarOpen={isOpenCalendar}
      />
      <div className={styles.map}>
        <Map
          formData={responseDate?.cars[0] || generateCarFormData()}
          user={user}
        />
      </div>
    </HeaderLayout>
  );
}

export default Allocations;
